webpackJsonp([114276838955818,60335399758886],{

/***/ 216:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(373);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(216);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Created by vaibhav on 31/3/18
	 */
	module.exports = {
	  siteTitle: 'Spin Auto', // Site title.
	  siteTitleAlt: 'Business', // Alternative site title for SEO.
	  siteLogo: '/logos/logo-512x512.png', // Logo used for SEO and manifest.
	  siteUrl: 'https://pensive-wing-1fefae.netlify.com', // Domain of your website without pathPrefix.
	  pathPrefix: '/', // Prefixes all links. For cases when deployed to example.github.io/gatsby-starter-business/.
	  siteDescription: 'Need a car? Come take one for a spin.', // Website description used for RSS feeds/meta description tag.
	  siteRss: '/rss.xml',
	  siteFBAppID: '', // FB Application ID for using app insights
	  googleTagManagerID: '', // GTM tracking ID.
	  disqusShortname: 'gatsby-business-starter', // Disqus shortname.
	  userName: 'Matthew Zygowicz',
	  userTwitter: 'spinauto',
	  userLocation: 'Chicago, Illinois',
	  userDescription: '',
	  copyright: 'Copyright © Spin Auto 2018. All Rights Reserved.', // Copyright string for the footer of the website and RSS feed.
	  themeColor: '#00d1b2', // Used for setting manifest and progress theme colors.
	  backgroundColor: '#ffffff' // Used for setting manifest background color.
	};

/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _config = __webpack_require__(40);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by vaibhav on 31/3/18
	 */
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    'footer',
	    { className: 'footer' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'content has-text-centered' },
	        _react2.default.createElement(
	          'p',
	          null,
	          _config2.default.copyright
	        )
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(71);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by vaibhav on 31/3/18
	 */
	var NavBar = function NavBar() {
	  return _react2.default.createElement(
	    'nav',
	    { className: 'navbar is-fixed-top is-link', 'aria-label': 'main navigation' },
	    _react2.default.createElement(
	      'div',
	      { className: 'navbar-brand ' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/', className: 'navbar-item' },
	        'Spin Auto'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'button navbar-burger', 'data-target': 'navMenu' },
	        _react2.default.createElement('span', null),
	        _react2.default.createElement('span', null),
	        _react2.default.createElement('span', null)
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'navbar-menu', id: 'navMenu' },
	      _react2.default.createElement(
	        'div',
	        { className: 'navbar-start' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'navbar-item', to: '/pricing' },
	          'Pricing'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'navbar-item', to: '/about' },
	          'About'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'navbar-end' },
	        _react2.default.createElement(
	          'div',
	          { className: 'navbar-item' },
	          _react2.default.createElement(
	            'div',
	            { className: 'field is-grouped' },
	            _react2.default.createElement(
	              'p',
	              { className: 'control' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                {
	                  id: 'contact-us-link',
	                  className: 'button is-primary is-outlined',
	                  to: '/contact' },
	                'Contact Us'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = NavBar;
	module.exports = exports['default'];

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(24);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _NavBar = __webpack_require__(371);
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _Footer = __webpack_require__(370);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(478);
	
	var _config = __webpack_require__(40);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        _config2.default.siteTitle
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: _config2.default.siteDescription })
	    ),
	    _react2.default.createElement(_NavBar2.default, null),
	    _react2.default.createElement(
	      'div',
	      null,
	      children()
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	}; /**
	    * Created by vaibhav on 31/3/18
	    */
	
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 478:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-3d0bb3ce231a1cc1ff1a.js